<template>
  <div class="course-manage">
    <div class="header">
      <h2>课程管理</h2>
    </div>
    
    <div class="search-bar">
      <span style="margin-right: 10px;">关键字:</span>
      <el-input
        v-model="searchKeyword"
        placeholder="请输入"
        style="width: 200px; margin-right: 20px;"
        @keyup.enter="searchCourses"
      ></el-input>
      <span style="margin-right: 10px;">分类:</span>
      <el-select v-model="selectedCategory" placeholder="请选择" style="width: 150px; margin-right: 20px;">
        <el-option label="全部分类" value=""></el-option>
        <el-option
          v-for="category in categories"
          :key="category.id"
          :label="category.name"
          :value="category.id"
        ></el-option>
      </el-select>
      <el-button @click="resetSearch">重置</el-button>
      <el-button type="primary" @click="searchCourses" style="margin-left: 10px;">搜索</el-button>
    </div>

    <div class="action-bar">
      <el-button type="primary" @click="addCourse">添加课程</el-button>
    </div>

    <el-table :data="courseList" style="width: 100%" v-loading="loading">
      <el-table-column prop="typeName" label="课程分类" min-width="120"></el-table-column>
      <el-table-column label="课程图片" width="120">
        <template slot-scope="scope">
          <img :src="scope.row.pictureUrl || '/static/img/default-course.jpg'" 
               style="width: 80px; height: 60px; object-fit: cover;" 
               alt="课程图片" />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="课程名称" min-width="150"></el-table-column>
      <el-table-column label="课程类型" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.courseType === 1 ? 'success' : 'warning'">
            {{ scope.row.courseType === 1 ? '免费' : 'VIP' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '上架中' : '已下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editCourse(scope.row)">编辑</el-button>
          <el-button 
            size="mini" 
            :type="scope.row.status === 1 ? 'warning' : 'success'" 
            @click="changeStatus(scope.row)">
            {{ scope.row.status === 1 ? '下架' : '上架' }}
          </el-button>
          <el-button size="mini" type="danger" @click="deleteCourse(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right;"
    ></el-pagination>

    <!-- 添加/编辑课程对话框 -->
    <el-dialog
      :title="isEdit ? '编辑课程' : '添加课程'"
      :visible.sync="showAddDialog"
      width="600px"
      @close="resetForm"
    >
      <el-form :model="courseForm" :rules="rules" ref="courseForm" label-width="100px">
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="courseForm.name" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item label="课程分类" prop="categoryId">
          <el-select v-model="courseForm.categoryId" placeholder="请选择分类" style="width: 100%;">
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教练" prop="instructor">
          <el-input v-model="courseForm.instructor" placeholder="请输入教练姓名"></el-input>
        </el-form-item>
        <el-form-item label="课程时长" prop="duration">
          <el-input-number v-model="courseForm.duration" :min="1" :max="300" placeholder="分钟"></el-input-number>
        </el-form-item>
        <el-form-item label="难度等级" prop="difficulty">
          <el-select v-model="courseForm.difficulty" placeholder="请选择难度" style="width: 100%;">
            <el-option label="初级" value="1"></el-option>
            <el-option label="中级" value="2"></el-option>
            <el-option label="高级" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            v-model="courseForm.description"
            placeholder="请输入课程描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="courseForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddDialog = false">取消</el-button>
        <el-button type="primary" @click="saveCourse" :loading="saving">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CourseManage',
  data() {
    return {
      loading: false,
      saving: false,
      showAddDialog: false,
      isEdit: false,
      searchKeyword: '',
      selectedCategory: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      courseList: [],
      categories: [],
      courseForm: {
        id: null,
        name: '',
        categoryId: '',
        instructor: '',
        duration: 30,
        difficulty: '1',
        description: '',
        status: 1
      },
      rules: {
        name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择课程分类', trigger: 'change' }
        ],
        instructor: [
          { required: true, message: '请输入教练姓名', trigger: 'blur' }
        ],
        duration: [
          { required: true, message: '请输入课程时长', trigger: 'blur' }
        ],
        difficulty: [
          { required: true, message: '请选择难度等级', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadCourses();
    this.loadCategories();
  },
  methods: {
    addCourse() {
      // 跳转到课程编辑页面，不传id表示新增
      this.$router.push('/yunying/course/edit');
    },
    async loadCourses() {
      this.loading = true;
      try {
        const params = {
          pageSize: this.pageSize,
          pageNumber: this.currentPage,
          name: this.searchKeyword || undefined,
          typeId: this.selectedCategory || undefined
        };
        
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/course/list',
          params: params
        });
        
        if (response.data.error === 10000) {
          const data = response.data.data;
          this.courseList = data.resModels || [];
          // 添加调试信息查看 status 字段的值和类型
          if (this.courseList.length > 0) {
            console.log('课程列表第一项的 status:', this.courseList[0].status, typeof this.courseList[0].status);
          }
          this.total = data.count || 0;
        } else {
          this.$message.error(response.data.message || '获取课程列表失败');
          this.courseList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取课程列表失败:', error);
        this.$message.error('获取课程列表失败，请检查网络连接');
        this.courseList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    async loadCategories() {
      try {
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/courseType/list',
          params: {
            status: 1, // 只获取启用的分类
            pageSize: 100, // 获取所有分类
            pageNumber: 1
          }
        });
        
        if (response.data.error === 10000) {
          const data = response.data.data;
          this.categories = data.resModels || [];
        } else {
          this.$message.error(response.data.message || '获取分类列表失败');
          this.categories = [];
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
        this.$message.error('获取分类列表失败，请检查网络连接');
        this.categories = [];
      }
    },
    searchCourses() {
      this.currentPage = 1;
      this.loadCourses();
    },
    resetSearch() {
      this.searchKeyword = '';
      this.selectedCategory = '';
      this.loadCourses();
    },
    editCourse(row) {
      // 跳转到课程编辑页面，传递课程id
      this.$router.push(`/yunying/course/edit/${row.id}`);
    },
    async deleteCourse(row) {
      this.$confirm('确认删除该课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v1/course/delete',
            params: {
              id: row.id
            }
          });

          if (response.data.error === 10000) {
            this.$message.success('删除成功');
            this.loadCourses();
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        } catch (error) {
          console.error('删除课程失败:', error);
          this.$message.error('删除失败，请检查网络连接');
        }
      });
    },
    async toggleStatus(row) {
      const action = row.status === 1 ? '禁用' : '启用';
      this.$confirm(`确认${action}该课程吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http({
            method: 'GET',
            url: this.$util.domain + '/adminapi/v1/course/updateStatus',
            params: {
              id: row.id,
              status: row.status === 1 ? 0 : 1
            }
          });

          if (response.data.error === 10000) {
            this.$message.success(`${action}成功`);
            this.loadCourses();
          } else {
            this.$message.error(response.data.message || `${action}失败`);
          }
        } catch (error) {
          console.error('状态切换失败:', error);
          this.$message.error(`${action}失败，请检查网络连接`);
        }
      });
    },
    async saveCourse() {
      this.$refs.courseForm.validate(async (valid) => {
        if (valid) {
          this.saving = true;
          try {
            const requestData = {
              name: this.courseForm.name,
              typeId: this.courseForm.categoryId,
              instructor: this.courseForm.instructor,
              duration: this.courseForm.duration,
              difficulty: parseInt(this.courseForm.difficulty),
              description: this.courseForm.description,
              status: this.courseForm.status
            };

            // 如果是编辑模式，添加id
            if (this.isEdit && this.courseForm.id) {
              requestData.id = this.courseForm.id;
            }

            const response = await this.$http({
              method: 'POST',
              url: this.$util.domain + '/adminapi/v1/course/save',
              body: JSON.stringify(requestData)
            });

            if (response.data.error === 10000) {
              this.$message.success(this.isEdit ? '编辑成功' : '添加成功');
              this.showAddDialog = false;
              this.loadCourses();
            } else {
              this.$message.error(response.data.message || '保存失败');
            }
          } catch (error) {
            console.error('保存课程失败:', error);
            this.$message.error('保存失败，请检查网络连接');
          } finally {
            this.saving = false;
          }
        }
      });
    },
    resetForm() {
      this.isEdit = false;
      this.courseForm = {
        id: null,
        name: '',
        categoryId: '',
        instructor: '',
        duration: 30,
        difficulty: '1',
        description: '',
        status: 1
      };
      if (this.$refs.courseForm) {
        this.$refs.courseForm.resetFields();
      }
    },
    getDifficultyType(difficulty) {
      const types = { '1': 'success', '2': 'warning', '3': 'danger' };
      return types[difficulty] || 'info';
    },
    getDifficultyText(difficulty) {
      const texts = { '1': '初级', '2': '中级', '3': '高级' };
      return texts[difficulty] || '未知';
    },
    formatDateTime(dateTime) {
      if (!dateTime) return '';
      
      // 如果是时间戳（数字）
      if (typeof dateTime === 'number') {
        return this.$util.dateFormat(new Date(dateTime), 'yyyy-MM-dd hh:mm:ss');
      }
      
      // 如果是日期字符串
      if (typeof dateTime === 'string') {
        return this.$util.dateFormat(new Date(dateTime), 'yyyy-MM-dd hh:mm:ss');
      }
      
      return dateTime;
    },
    changeStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1;
      const statusText = newStatus === 1 ? '上架' : '下架';
      
      this.$confirm(`确定要${statusText}课程"${row.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用API修改课程状态
        this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/course/change',
          params: {
            id: row.id,
            status: newStatus
          }
        }).then(response => {
          if (response.data.error === 10000) {
            this.$message.success(`课程${statusText}成功`);
            // 更新本地数据
            row.status = newStatus;
          } else {
            this.$message.error(response.data.message || `课程${statusText}失败`);
          }
        })
          .catch(error => {
            console.error('修改课程状态失败:', error);
            this.$message.error(`课程${statusText}失败`);
          });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    downloadCourse(row) {
      // 模拟下载功能
      this.$message.info(`正在下载课程：${row.name}`);
      // 实际项目中可以调用下载API或生成下载链接
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadCourses();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCourses();
    }
  }
}
</script>

<style scoped>
.course-manage {
  padding: 20px;
}

.header {
  margin-bottom: 20px;
}

.search-bar {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
}

.dialog-footer {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// courseManage.vue?c406ddea